import {
  PortableText,
  type PortableTextBlock,
  type PortableTextComponents,
} from '@portabletext/react'
// import { Lexend } from 'next/font/google'
import React from 'react'
import { Prose } from '../Prose'

interface Cell {
  _key: string
  content: PortableTextBlock[]
}

interface TableRow {
  _key: string
  cells: Cell[]
}

interface TableBlockProps {
  value: {
    rows?: TableRow[]
  }
}

// const lexend = Lexend({
//   subsets: ['latin'],
//   weight: ['300', '400', '500', '700'],
//   display: 'swap',
// })

export interface TableProps {
  cells: PortableTextBlock[]
}

const tablePortableTextComponents: PortableTextComponents = {
  types: {},
  marks: {
    code: ({ children }) => (
      <span className="break-words rounded bg-slate-700 px-0.5">
        <code className="prose prose-code:!font-mono text-[14px] font-normal leading-[24.5px] text-sky-300">
          {children}
        </code>
      </span>
    ),
  },
  block: {
    p: ({ children }) => <p className="text-sm">{children}</p>,
    a: ({ children }) => <a className="text-sm">{children}</a>,
  },
}

export default function TableBlock({ value }: TableBlockProps) {
  const { rows } = value

  if (!rows || rows.length < 2) {
    return null
  }

  // const headerRow = rows[0]
  const dataRows = rows

  return (
    <div className="my-7 w-full overflow-x-auto">
      <table className="w-full border-collapse text-sm leading-6 text-[#94a3b8]">
        {/* <thead>
          <tr>
            {headerRow.cells.map((cell, index) => (
              <th
                key={index}
                className={`border-b border-gray-700 py-2 pr-2 text-left ${lexend.className} font-medium text-white`}
              >
                <Prose className="prose-a:!text-sm !w-full text-sm font-medium">
                  <PortableText
                    value={cell.content}
                    components={tablePortableTextComponents}
                  />
                </Prose>
              </th>
            ))}
          </tr>
        </thead> */}
        <tbody>
          {dataRows.map((row, rowIndex) => (
            <tr
              key={row._key || rowIndex}
              className="border-b border-gray-700 last:border-0"
            >
              {row.cells.map((cell, cellIndex) => (
                <td key={cellIndex} className=" py-2 pr-2 text-left">
                  <Prose className="prose-a:!text-sm !w-full text-sm font-normal">
                    <PortableText
                      value={cell.content}
                      components={tablePortableTextComponents}
                    />
                  </Prose>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
